var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app-bar',{staticClass:"ma0 pa-0",attrs:{"fixed":"","dark":""}},[_c('v-app-bar-nav-icon',{on:{"click":function($event){return _vm.$emit('drawer', true)}}}),_c('v-toolbar-title',[_vm._v("\n    "+_vm._s(_vm.title)+"\n  ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }